import { LIKE_ITEM, UNLIKE_ITEM, FETCH_ITEM_BY_MODEL } from "./apiEndpoints";

export const likeItem = async (itemId) => {
  const response = await fetch(LIKE_ITEM(itemId), {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const unlikeItem = async (itemId) => {
  const response = await fetch(UNLIKE_ITEM(itemId), {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchItemByModelName = async (modelName) => {
  try {
    const response = await fetch(FETCH_ITEM_BY_MODEL(modelName));
    if (!response.ok) {
      throw new Error("Item not found");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching item:", error);
    throw error;
  }
};
